<div class="filter-sidenav-container">
  <div class="filter-header">
    <div class="header-title-group">
      <h2>{{ 'request_v2.filter.title' | translate }}</h2>
    </div>
    <div class="header-actions-group">
      <button mat-icon-button
              class="save-filter-btn"
              *ngIf="hasActiveFilters()"
              (click)="startSave()"
              [matTooltip]="'request_v2.filter.save_filter' | translate">
        <mat-icon>bookmark_border</mat-icon>
      </button>
      <button class="reset-button" mat-flat-button color="primary" *ngIf="hasActiveFilters()" (click)="reset()">
        {{ 'request_v2.filter.reset' | translate }}
      </button>
    </div>
  </div>

  <!-- Saved Filters Accordion -->
  <div class="saved-filters-section" *ngIf="savedFilters.length > 0 || isSaving">
    <div class="saved-filters-header" (click)="toggleAccordion()">
      <span class="saved-filters-title">
        {{ 'request_v2.filter.saved_filters' | translate }}
        <span class="saved-filters-count" *ngIf="savedFilters.length > 0">({{ savedFilters.length }})</span>
      </span>
      <mat-icon class="accordion-icon" [class.open]="isAccordionOpen">expand_more</mat-icon>
    </div>

    <div class="saved-filters-body" *ngIf="isAccordionOpen">
      <div class="saved-filter-item" *ngFor="let sf of savedFilters" (click)="onLoadFilter(sf)">
        <span class="saved-filter-name">{{ sf.name }}</span>
        <button mat-icon-button class="delete-filter-btn" (click)="onDeleteFilter(sf.id, $event)">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="save-filter-input-row" *ngIf="isSaving">
        <input matInput
               [formControl]="filterNameControl"
               [placeholder]="'request_v2.filter.filter_name_placeholder' | translate"
               (keyup.enter)="confirmSave()"
               (keyup.escape)="cancelSave()"
               class="filter-name-input"
               #filterNameInput>
        <button mat-icon-button (click)="confirmSave()" [disabled]="!filterNameControl.value?.trim()">
          <mat-icon>check</mat-icon>
        </button>
        <button mat-icon-button (click)="cancelSave()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>
  </div>

  <div class="filter-content" [formGroup]="filterForm">
    
    <!-- Requester -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.requester' | translate }}</h3> <!-- "Requester" -->
        <button mat-button color="primary" class="clear-btn" *ngIf="selectedRequesters.length > 0" (click)="clearField('requester')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput
               placeholder="{{ 'request_v2.filter.search_requester' | translate }}"
               #requesterInput
               [formControl]="requesterSearchCtrl"
               [matAutocomplete]="autoRequester">
      </mat-form-field>
      
      <mat-autocomplete #autoRequester="matAutocomplete" (optionSelected)="selectRequester($event)" class="user-autocomplete">
        <mat-option *ngFor="let user of filteredRequesters$ | async" [value]="user">
          <div class="user-row">
            <img *ngIf="user.picture" [src]="user.picture" class="user-avatar" alt="Avatar">
            <div *ngIf="!user.picture" class="user-avatar">
              <mat-icon>person</mat-icon>
            </div>
            <div class="user-info">
              <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
              <span class="user-detail">{{ user.email }}</span>
              <span class="user-detail" *ngIf="user.phone">{{ user.phone }}</span>
            </div>
          </div>
        </mat-option>
      </mat-autocomplete>

      <div class="selected-user-list" *ngIf="selectedRequesters.length > 0">
        <div class="selected-user-card" *ngFor="let user of selectedRequesters">
          <img *ngIf="user.picture" [src]="user.picture" class="user-avatar" alt="Avatar">
          <div *ngIf="!user.picture" class="user-avatar">
            <mat-icon>person</mat-icon>
          </div>
          <div class="user-info">
            <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
            <span class="user-detail">{{ user.email }}</span>
            <span class="user-detail" *ngIf="user.phone">{{ user.phone }}</span>
          </div>
          <button mat-icon-button class="remove-btn" (click)="removeRequester(user)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Status -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.status' | translate }}</h3> <!-- "Status" -->
        <button mat-button color="primary" class="clear-btn" *ngIf="getSelectedStatuses().length > 0" (click)="clearField('status')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <div class="checkbox-list">
        <mat-checkbox *ngFor="let status of statusTypes"
                      [checked]="isStatusSelected(status._id)"
                      (change)="toggleStatus(status._id, $event.checked)">
          {{ status.name | titlecase }}
        </mat-checkbox>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Creation Date -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.creation_date' | translate }}</h3> <!-- "Creation Date" -->
        <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('createdAtFrom')?.value || filterForm.get('createdAtTo')?.value" (click)="clearField('creationDate')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <mat-form-field appearance="outline" class="full-width date-field">
        <mat-date-range-input [rangePicker]="creationDatePicker" [max]="maxDate">
          <input matStartDate formControlName="createdAtFrom" placeholder="{{ 'request_v2.filter.date_placeholder' | translate }}">
          <input matEndDate formControlName="createdAtTo" placeholder="{{ 'request_v2.filter.date_placeholder' | translate }}">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="creationDatePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #creationDatePicker [panelClass]="'montserrat-datepicker'"></mat-date-range-picker>
      </mat-form-field>
    </div>

    <mat-divider></mat-divider>

    <!-- SLA Date -->
    <!-- <div class="filter-section">
      <h3>{{ 'request_v2.list.sla_date' | translate }}</h3> 
      <mat-form-field appearance="outline" class="full-width date-field">
        <mat-icon matPrefix>calendar_today</mat-icon>
        <input matInput [matDatepicker]="slaPicker" formControlName="slaDate" placeholder="yyyy-mm-dd">
        <mat-datepicker-toggle matSuffix [for]="slaPicker"></mat-datepicker-toggle>
        <mat-datepicker #slaPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-divider></mat-divider> -->

    <!-- Department  -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.department' | translate }}</h3> 
        <button mat-button color="primary" class="clear-btn" *ngIf="getSelectedValues('departments').length > 0" (click)="clearField('departments')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <div class="checkbox-list">
        <mat-checkbox *ngFor="let dept of departmentTypes"
                      [checked]="isValueSelected('departments', dept._id)"
                      (change)="toggleSelection('departments', dept._id, $event.checked)">
          {{ dept.name }}
        </mat-checkbox>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Category -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.category' | translate }}</h3> <!-- "Category" -->
        <button mat-button color="primary" class="clear-btn" *ngIf="getSelectedValues('categories').length > 0" (click)="clearField('categories')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <div class="checkbox-list">
        <mat-checkbox *ngFor="let cat of categories"
                      [checked]="isValueSelected('categories', cat.id)"
                      (change)="toggleSelection('categories', cat.id, $event.checked)">
          {{ cat.name }}
        </mat-checkbox>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Subcategory -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.subcategory' | translate }}</h3>
        <button mat-button color="primary" class="clear-btn" *ngIf="getSelectedValues('subCategory').length > 0" (click)="clearField('subCategory')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <div class="checkbox-list">
        <mat-checkbox *ngFor="let sub of filteredSubcategories"
                      [checked]="isValueSelected('subCategory', sub.id)"
                      (change)="toggleSelection('subCategory', sub.id, $event.checked)">
          {{ sub.name }}
        </mat-checkbox>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Tags -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.tags' | translate }}</h3>
        <div class="tags-mode-toggle" *ngIf="selectedTags.length > 1">
          <button
            class="mode-button"
            [class.active]="tagsFilterMode === 'AND'"
            (click)="toggleTagsFilterMode()">
            {{ (tagsFilterMode === 'AND' ? 'request_v2.filter.tags_mode_and' : 'request_v2.filter.tags_mode_or') | translate }}
          </button>
        </div>
        <button mat-button color="primary" class="clear-btn" *ngIf="selectedTags.length > 0" (click)="clearField('tags')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <mat-chip-list #tagFilterChipList>
        <input
          [placeholder]="'request_v2.filter.search_tags' | translate"
          [formControl]="tagSearchCtrl"
          [matChipInputFor]="tagFilterChipList"
          [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
          (matChipInputTokenEnd)="addTagFilter($event)"
          [matAutocomplete]="tagFilterAuto"
          (focus)="onTagInputFocus()"
        />
        <mat-chip
          *ngFor="let tag of selectedTags"
          [removable]="true"
          (removed)="removeTagFilter(tag)">
          {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <mat-autocomplete #tagFilterAuto="matAutocomplete" (optionSelected)="selectTagSuggestion($event)">
        <mat-option *ngFor="let tag of filteredTagSuggestions" [value]="tag">
          {{ tag }}
        </mat-option>
      </mat-autocomplete>
    </div>

    <mat-divider></mat-divider>

    <!-- Subtask Assigned To -->
    <div class="filter-section">
      <div class="section-header">
        <h3>{{ 'request_v2.filter.subtask_assigned_to' | translate }}</h3> <!-- "Subtask Assigned To" -->
        <button mat-button color="primary" class="clear-btn" *ngIf="selectedAssignees.length > 0" (click)="clearField('assignee')">
          <mat-icon>close</mat-icon> {{ 'request_v2.list.clear_filters' | translate }}
        </button>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput
               placeholder="{{ 'request_v2.filter.search_assignee' | translate }}"
               #assigneeInput
               [formControl]="assigneeSearchCtrl"
               [matAutocomplete]="autoAssignee">
      </mat-form-field>

      <mat-autocomplete #autoAssignee="matAutocomplete" (optionSelected)="selectAssignee($event)" class="user-autocomplete">
        <mat-option *ngFor="let user of filteredAssignees$ | async" [value]="user">
          <div class="user-row">
            <img *ngIf="user.picture" [src]="user.picture" class="user-avatar" alt="Avatar">
            <div *ngIf="!user.picture" class="user-avatar">
              <mat-icon>person</mat-icon>
            </div>
            <div class="user-info">
              <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
              <span class="user-detail">{{ user.email }}</span>
              <span class="user-detail" *ngIf="user.phone">{{ user.phone }}</span>
            </div>
          </div>
        </mat-option>
      </mat-autocomplete>

      <div class="selected-user-list" *ngIf="selectedAssignees.length > 0">
        <div class="selected-user-card" *ngFor="let user of selectedAssignees">
          <img *ngIf="user.picture" [src]="user.picture" class="user-avatar" alt="Avatar">
          <div *ngIf="!user.picture" class="user-avatar">
            <mat-icon>person</mat-icon>
          </div>
          <div class="user-info">
            <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
            <span class="user-detail">{{ user.email }}</span>
            <span class="user-detail" *ngIf="user.phone">{{ user.phone }}</span>
          </div>
          <button mat-icon-button class="remove-btn" (click)="removeAssignee(user)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

  </div>
</div>
